exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-cg-electric-cg-electric-tsx": () => import("./../../../src/pages/cg-electric/CGElectric.tsx" /* webpackChunkName: "component---src-pages-cg-electric-cg-electric-tsx" */),
  "component---src-pages-cg-electric-index-tsx": () => import("./../../../src/pages/cg-electric/index.tsx" /* webpackChunkName: "component---src-pages-cg-electric-index-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

